import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import useCachedResources from 'hooks/useCachedResources';
import Navigation from 'navigation/Navigation';
import "./src/translation/config"
import * as ScreenOrientation from 'expo-screen-orientation';
import { Dimensions, Platform } from 'react-native';

function getCloverTypeByDimensions() {
  const { width, height } = Dimensions.get('screen');

  if (width > height) {
    return 'Mini';
  } else {
    return 'Flex';
  }
}

async function lockOrientationBasedOnDimensions() {
  const type = getCloverTypeByDimensions();

  if (type === 'Flex') {
    await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT_UP);
  } else if (type === 'Mini') {
    await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.LANDSCAPE_RIGHT);
  }
}

export default function App(): JSX.Element | null {
  const isLoadingComplete = useCachedResources();

  React.useEffect(() => {
    if (Platform.OS === 'android') {
      lockOrientationBasedOnDimensions();
    }
  }, []);

  if (!isLoadingComplete) {
    return null;
  } else {
    return (
      <SafeAreaProvider>
        <Navigation />
        <StatusBar />
      </SafeAreaProvider>
    );
  }
}
